<template>
  <v-dialog v-model="displayForm" persistent max-width="980px">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card :disabled="loading" :loading="loading">
        <v-card-title>
          <span class="headline" v-if="item">Update Item</span>
          <span class="headline" v-else>Add Item</span>
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="message"
            type="error"
            dismissible
            transition="scale-transition"
          >{{ message }}</v-alert>

          <v-container>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="model.username" label="Username" :rules="mandatoryRules"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="model.email" label="Email" :rules="mandatoryRules"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="model.firstname" label="Firstname" :rules="mandatoryRules"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="model.lastname" label="Lastname" :rules="mandatoryRules"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="model.password" label="Password" :type="'password'"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="roles"
                  v-model="model.role"
                  label="Role"
                  item-text="label"
                  item-value="value"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="subtitle-2">Shop access</p>
                <v-checkbox
                  v-for="shop in shops"
                  :key="'_shop_'+shop.id"
                  :label="shop.name"
                  v-model="shopAccess[shop.id]"
                  :true-value="true"
                  :false-value="false"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel()" :disabled="loading">Cancel</v-btn>
          <v-btn
            v-if="item"
            color="blue darken-1"
            text
            @click="update()"
            :disabled="loading"
          >Update</v-btn>
          <v-btn v-else color="blue darken-1" text @click="add()" :disabled="loading">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
function getDefaultData() {
  return {
    model: {
      username: null,
      email: null,
      password: null,
      role: null
    },
    shopAccess: {},
    roles: [
      { value: 9, label: "Admin" },
      { value: 6, label: "Fitter" },
      { value: 3, label: "Builder" },
      { value: 2, label: "External Fitter" },
      { value: 1, label: "Shop Keeper" },
      { value: 0, label: "Client" }
    ],
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    valid: null,
    message: null
  };
}

export default {
  props: ["item", "open"],
  data: getDefaultData,
  computed: {
    ...mapGetters("shops", ["shops"]),
    ...mapGetters("users", ["loading"]),
    displayForm: function() {
      return this.open;
    },
  },
  watch: {
    item: function(newVal) {
      // watch it
      Object.assign(this.model, newVal);
      if(newVal) {
        this.dispatchShop(newVal.shops);
      }
    }
  },
  methods: {
    ...mapActions("users",{addUser:'add', updateUser:'update'}),
    dispatchShop(shops){
      if(shops && shops.length) {
        const shopAccess = {}
        for(let shop of shops){
          shopAccess[shop.shop_id] = true;
        }
        Object.assign(this.shopAccess, shopAccess);
      }
    },
    add() {
      if (this.$refs.form.validate()) {
        this.addUser({
            model: this.model,
            shops: this.shopAccess
          })
          .then(result => {
            if (result.id) {
              this.$emit("add");
              this.resetForm();
            } else {
              this.message = result.message;
            }
          });
      }
    },
    update() {
      if (this.$refs.form.validate()) {
        this.updateUser({
            model: this.model,
            shops: this.shopAccess
          })
          .then(result => {
            if (result.user.id) {
              this.$emit("update");
              this.resetForm();
            } else {
              this.message = result.message;
            }
          });
      }
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
